import { render, staticRenderFns } from "./FormSelectOption.vue?vue&type=template&id=2e4b89df&scoped=true"
import script from "./FormSelectOption.vue?vue&type=script&lang=js"
export * from "./FormSelectOption.vue?vue&type=script&lang=js"
import style0 from "./form-select-option.scss?vue&type=style&index=0&id=2e4b89df&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4b89df",
  null
  
)

export default component.exports